export const SISFieldEnum = {
  StudentNumber: 'StudentNumber',
  ServingNumber: 'ServingNumber',
  StudentFirstName: 'StudentFirstName',
  StudentMiddleName: 'StudentMiddleName',
  StudentLastName: 'StudentLastName',
  Site: 'Site',
  Grade: 'Grade',
  Teacher: 'Teacher',
  Birthdate: 'Birthdate',
  SSN: 'SSN',
  ParentName: 'ParentName',
  ParentEmail: 'ParentEmail',
  ParentPhoneNumber: 'ParentPhoneNumber',
  Address: 'Address',
  Language: 'Language',
  Allergies: 'Allergies',
  StudentId: 'studentId',
  StudentStatusCode: 'StudentStatusCode',
  HasManualBeenRunNotes: 'HasManualBeenRunNotes',
};

export const SISStudentPreviewEnum = {
  Address1: 'Address1',
  Allergies: 'Allergies',
  Birthdate: 'Birthdate',
  City: 'City',
  Enroll: 'Enroll',
  Grade: 'Grade',
  LanguageId: 'LanguageId',
  PSEnrollStatus: 'PSEnrollStatus',
  ParentEmail: 'ParentEmail',
  ParentFirstName: 'ParentFirstName',
  ParentLastName: 'ParentLastName',
  ParentPhoneNumber: 'ParentPhoneNumber',
  SSN: 'SSN',
  ServingNumber: 'ServingNumber',
  Site: 'Site',
  State: 'State',
  StudentFirstName: 'StudentFirstName',
  StudentMiddleName: 'StudentMiddleName',
  StudentLastName: 'StudentLastName',
  StudentNumber: 'StudentNumber',
  Teacher: 'Teacher',
  ZipCode: 'ZipCode',
};

const getSkip = () => {
  return { text: 'Skip', value: 'Skip' };
};

const getOption = (name) => {
  if (typeof name === 'object') {
    return name;
  }

  return { text: name, value: name };
};

//powerschool
export const PowerSchoolMapOptions = [
  {
    key: SISFieldEnum.StudentNumber,
    value: 'Student Number',
  },
  {
    key: SISFieldEnum.ServingNumber,
    value: 'Serving Number',
  },
  {
    key: SISFieldEnum.StudentFirstName,
    value: 'Student First Name',
  },
  {
    key: SISFieldEnum.StudentLastName,
    value: 'Student Last Name',
  },
  {
    key: SISFieldEnum.Site,
    value: 'Site',
  },
  {
    key: SISFieldEnum.Grade,
    value: 'Grade',
  },
  {
    key: SISFieldEnum.Teacher,
    value: 'Teacher',
  },
  {
    key: SISFieldEnum.Birthdate,
    value: 'Birth Date',
  },
  {
    key: SISFieldEnum.SSN,
    value: 'SSN',
  },
  {
    key: SISFieldEnum.ParentName,
    value: 'Parent Name',
  },
  {
    key: SISFieldEnum.ParentEmail,
    value: 'Parent Email',
  },
  {
    key: SISFieldEnum.ParentPhoneNumber,
    value: 'Parent Phone Number',
  },
  {
    key: SISFieldEnum.Address,
    value: 'Address',
  },
  {
    key: SISFieldEnum.Language,
    value: 'Language',
  },
  {
    key: SISFieldEnum.Allergies,
    value: 'Allergies',
  },
];

export const PowerSchoolFieldEnum = {
  BaseUrl: 'BaseUrl',
  ClientId: 'ClientId',
  ClientSecret: 'ClientSecret',
  CallbackURL: 'CallBack_Url',
  Enabled: 'Enabled',
  ExportEnabled: 'ExportEnabled',
  AutoTransferTime: 'AutoTransferTime',

  //StudentNumber & ServingNumber
  LocalId: 'Local Id',
  StateProvinceId: 'State Province Id',

  //StudentFirstName
  FirstName: 'First Name',

  //StudentLastName
  LastName: 'Last Name',

  //Site - has SiteMapping button
  SchoolNumber: 'School Number',
  SchoolId: 'School Id',
  SiteMapping: 'SiteMapping',

  //Grade - skippable -  has GradeMapping button
  GradeLevel: 'Grade Level',
  GradeMapping: 'GradeMapping',

  //Teacher - skippable
  HomeRoom: 'Home Room',
  TeacherSchedule: 'Teacher Schedule',
  TeacherMapping: 'TeacherMapping',

  //Birthdate - skippable
  BirthDate: 'Birth Date',

  //SSN - skippable
  SSN: 'SSN',

  //ParentName - skippable
  Guardian: 'Guardian',
  Mother: 'Mother',
  Father: 'Father',
  EmergencyContactName1: 'Emergency Contact Name1',

  //ParentEmail - skippable
  Email: 'Email',
  GuardianEmail: 'Guardian Email',

  //ParentPhoneNumber - skippable
  GuardianNumber: 'Guardian Number',
  MainNumber: 'Main Number',
  EmergencyPhone1: 'Emergency Phone1',
  EmergencyPhone2: 'Emergency Phone2',

  //Address - skippable
  Mailing: 'Mailing',
  Physical: 'Physical',

  //Language - skippable - has LanguageMapping button
  PrimaryLanguage: 'Primary Language',
  LanguageMapping: 'LanguageMapping',

  //Allergies - skippable
  Allergies: 'Allergies',
};

export const PowerSchoolMapConfig = {
  [SISFieldEnum.StudentNumber]: {
    options: [
      getOption(PowerSchoolFieldEnum.LocalId),
      getOption(PowerSchoolFieldEnum.StateProvinceId),
    ],
  },
  [SISFieldEnum.ServingNumber]: {
    options: [
      getOption(PowerSchoolFieldEnum.LocalId),
      getOption(PowerSchoolFieldEnum.StateProvinceId),
      getSkip(),
    ],
  },
  [SISFieldEnum.StudentFirstName]: {
    options: [getOption(PowerSchoolFieldEnum.FirstName)],
  },
  [SISFieldEnum.StudentLastName]: {
    options: [getOption(PowerSchoolFieldEnum.LastName)],
  },
  [SISFieldEnum.Site]: {
    childMap: { name: 'Map Sites', key: PowerSchoolFieldEnum.SiteMapping },
    options: [
      getOption(PowerSchoolFieldEnum.SchoolNumber),
      getOption(PowerSchoolFieldEnum.SchoolId),
    ],
  },
  [SISFieldEnum.Grade]: {
    childMap: { name: 'Map Grades', key: PowerSchoolFieldEnum.GradeMapping },
    options: [getOption(PowerSchoolFieldEnum.GradeLevel), getSkip()],
  },
  [SISFieldEnum.Teacher]: {
    options: [
      getOption(PowerSchoolFieldEnum.HomeRoom),
      getOption(PowerSchoolFieldEnum.TeacherSchedule),
      getSkip(),
    ],
    childMap: {
      name: 'Set Teacher Parameters',
      key: PowerSchoolFieldEnum.TeacherMapping,
    },
  },
  [SISFieldEnum.Birthdate]: {
    options: [getOption(PowerSchoolFieldEnum.BirthDate), getSkip()],
  },
  [SISFieldEnum.SSN]: {
    options: [getOption(PowerSchoolFieldEnum.SSN), getSkip()],
  },
  [SISFieldEnum.ParentName]: {
    options: [
      getOption(PowerSchoolFieldEnum.Guardian),
      getOption(PowerSchoolFieldEnum.Mother),
      getOption(PowerSchoolFieldEnum.Father),
      getOption(PowerSchoolFieldEnum.EmergencyContactName1),
      getSkip(),
    ],
  },
  [SISFieldEnum.ParentEmail]: {
    options: [
      getOption(PowerSchoolFieldEnum.Email),
      getOption(PowerSchoolFieldEnum.GuardianEmail),
      getSkip(),
    ],
  },
  [SISFieldEnum.ParentPhoneNumber]: {
    options: [
      getOption(PowerSchoolFieldEnum.GuardianNumber),
      getOption(PowerSchoolFieldEnum.MainNumber),
      getOption(PowerSchoolFieldEnum.EmergencyPhone1),
      getOption(PowerSchoolFieldEnum.EmergencyPhone2),
      getSkip(),
    ],
  },
  [SISFieldEnum.Address]: {
    options: [
      getOption(PowerSchoolFieldEnum.Mailing),
      getOption(PowerSchoolFieldEnum.Physical),
      getSkip(),
    ],
  },
  [SISFieldEnum.Language]: {
    childMap: {
      name: 'Map Languages',
      key: PowerSchoolFieldEnum.LanguageMapping,
    },
    options: [getOption(PowerSchoolFieldEnum.PrimaryLanguage), getSkip()],
  },
  [SISFieldEnum.Allergies]: {
    options: [getOption(PowerSchoolFieldEnum.Allergies), getSkip()],
    props: { upward: true },
  },
};

//powerschool export
export const PowerSchoolExportFieldEnum = {
  FTPFileName: 'FTPFileName',
  FTPShowBalance: 'FTPShowBalance',
  FTPShowStatus: 'FTPShowStatus',
  ExportEnabled: 'ExportEnabled',
  ExportFields: 'ExportFields',
  ExportTime: 'ExportTime',
};

//vendorlink
export const VendorLinkMapOptions = [
  {
    key: SISFieldEnum.StudentNumber,
    value: 'Student Number',
  },
  {
    key: SISFieldEnum.StudentFirstName,
    value: 'Student First Name',
  },
  {
    key: SISFieldEnum.StudentMiddleName,
    value: 'Student Middle Name',
  },
  {
    key: SISFieldEnum.StudentLastName,
    value: 'Student Last Name',
  },
  {
    key: SISFieldEnum.Site,
    value: 'Site',
  },
  {
    key: SISFieldEnum.Grade,
    value: 'Grade',
  },
  {
    key: SISFieldEnum.Teacher,
    value: 'Teacher',
  },
  {
    key: SISFieldEnum.Birthdate,
    value: 'Birth Date',
  },
  {
    key: SISFieldEnum.SSN,
    value: 'SSN',
  },
  {
    key: SISFieldEnum.ParentName,
    value: 'Parent Name',
  },
  {
    key: SISFieldEnum.ParentEmail,
    value: 'Parent Email',
  },
  {
    key: SISFieldEnum.ParentPhoneNumber,
    value: 'Parent Phone Number',
  },
  {
    key: SISFieldEnum.Address,
    value: 'Address',
  },
  {
    key: SISFieldEnum.Language,
    value: 'Language',
  },
  // {
  //   key: SISFieldEnum.Allergies,
  //   value: 'Allergies',
  // },
  {
    key: SISFieldEnum.StudentStatusCode,
    value: 'Student Status Code',
  },
];

export const vendorLinkPreviewFields = {
  StudentPersonalRefId: 'Student Personal Ref Id',
  SchoolInfoRefId: 'School Info Ref Id',
  StudentNumber: 'Student Number',
  StudentFirstName: 'Student First Name',
  StudentLastName: 'Student Last Name',
  StudentMiddleName: 'Student Middle Name',
  Site: 'Site',
  Grade: 'Grade',
  Teacher: 'Teacher',
  Birthdate: 'Date of Birth',
  SSN: 'SSN',
  ParentFirstName: 'Parent First Name',
  ParentLastName: 'Parent Last Name',
  ParentEmail: 'Parent Email',
  ParentPhoneNumber: 'Parent Phone Number',
  Address1: 'Address 1',
  Address2: 'Address 2',
  City: 'City',
  State: 'State',
  ZipCode: 'Zip Code',
  VLEnrollStatus: 'VLEnrollStatus',
  LanguageId: 'Language Id',
};

export const VendorLinkFieldEnum = {
  Enabled: 'Enabled',
  BaseUrl: 'BaseUrl',
  VendorId: 'VendorId',
  VendorKey: 'VendorKey',
  LEAInfoRefId: 'LEAInfoRefId',

  //StudentNumber & Site
  LocalId: 'LocalId',

  //StudentFirstName
  FirstName: 'FirstName',

  //StudentMiddleName
  MiddleName: 'MiddleName',

  //StudentLastName
  LastName: 'LastName',

  //Site - has SiteMapping button
  StateProvinceId: 'StateProvinceId',
  SiteMapping: 'SiteMapping',

  //Grade - skippable -  has GradeMapping button
  Grade: 'Code',
  GradeMapping: 'GradeMapping',

  //Teacher - skippable
  Description: 'Description',
  RoomNumber: 'RoomNumber',
  FullName: 'FullName',

  //Birthdate - skippable
  BirthDate: 'BirthDate',

  //SSN - skippable
  SSN: { text: '0004 - SSN', value: '0004' },

  //ParentName - skippable
  ParentName: 'Parent Name',

  //ParentEmail - skippable
  Primary: 'Primary',
  Alternate1: 'Alternate1',
  Alternate2: 'Alternate2',
  Alternate3: 'Alternate3',
  Alternate4: 'Alternate4',

  //ParentPhoneNumber - skippable
  MainTelephoneNumber: { text: '0096 - MainTelephoneNumber', value: '0096' },
  AlternateTelephoneNumber: {
    text: '0350 - AlternateTelephoneNumber',
    value: '0350',
  },
  Cell: { text: '0351 - Cell', value: '0351' },
  Texting: { text: '0352 - Texting', value: '0352' },
  MotherCell: { text: '0353 - MotherCell', value: '0353' },
  FatherCell: { text: '0354 - FatherCell', value: '0354' },
  Work: { text: '0355 - Work', value: '0355' },
  MotherWork: { text: '0356 - MotherWork', value: '0356' },
  FatherWork: { text: '0357 - FatherWork', value: '0357' },
  AnsweringService: { text: '0359 - AnsweringService', value: '0359' },
  BeeperNumber: { text: '0370 - BeeperNumber', value: '0370' },
  AppointmentTelephoneNumber: {
    text: '0400 - AppointmentTelephoneNumber',
    value: '0400',
  },
  TelexNumber: { text: '0426 - TelexNumber', value: '0426' },
  Telemail: { text: '0437 - Telemail', value: '0437' },
  VoiceMail: { text: '0448 - VoiceMail', value: '0448' },
  InstantMessagingNumber: {
    text: '0478 - InstantMessagingNumber',
    value: '0478',
  },
  MediaConferencingNumber: {
    text: '0486 - MediaConferencingNumber',
    value: '0486',
  },
  FacsimileNumber: { text: '2364 - FacsimileNumber', value: '2364' },

  //Address - skippable
  MailingAddress: { text: '0123 - MailingAddress', value: '0123' },
  ShippingAddress: { text: '0124 - ShippingAddress', value: '0124' },
  PhysicalLocationAddress: {
    text: '0765 - PhysicalLocationAddress',
    value: '0765',
  },
  OtherHomeAddress: { text: '1073 - OtherHomeAddress', value: '1073' },
  EmployerAddress: { text: '1074 - EmployerAddress', value: '1074' },
  EmploymentAddress: { text: '1075 - EmploymentAddress', value: '1075' },
  OtherOrganizationAddress: {
    text: '2382 - OtherOrganizationAddress',
    value: '2382',
  },

  //Language - skippable - has LanguageMapping button
  CorrespondenceLanguage: {
    text: '1035 - Correspondencelanguage',
    value: '1035',
  },
  DominantLanguage: { text: '1036 - DominantLanguage', value: '1036' },
  HomeLanguage: { text: '1037 - HomeLanguage', value: '1037' },
  NativeLanguage: { text: '1038 - NativeLanguage', value: '1038' },
  LanguageMapping: 'LanguageMapping',

  // //Allergies - skippable
  // Allergies: 'Allergies',

  //StudentStatusCode - has StatusCodeMapping button
  StudentStatusCode: 'StudentStatusCode',
  StatusCodeMapping: 'StudentStatusCodeMapping',
  StudentId: 'StudentId',
};

export const VendorLinkMapConfig = {
  [SISFieldEnum.StudentNumber]: {
    options: [
      getOption(VendorLinkFieldEnum.LocalId),
      getOption(VendorLinkFieldEnum.StateProvinceId),
    ],
  },
  [SISFieldEnum.StudentFirstName]: {
    options: [getOption(VendorLinkFieldEnum.FirstName)],
  },
  [SISFieldEnum.StudentMiddleName]: {
    options: [getOption(VendorLinkFieldEnum.MiddleName), getSkip()],
  },
  [SISFieldEnum.StudentLastName]: {
    options: [getOption(VendorLinkFieldEnum.LastName)],
  },
  [SISFieldEnum.Site]: {
    childMap: { name: 'Map Sites', key: VendorLinkFieldEnum.SiteMapping },
    options: [
      getOption(VendorLinkFieldEnum.StateProvinceId),
      getOption(VendorLinkFieldEnum.LocalId),
    ],
  },
  [SISFieldEnum.Grade]: {
    childMap: { name: 'Map Grades', key: VendorLinkFieldEnum.GradeMapping },
    options: [getOption(VendorLinkFieldEnum.Grade), getSkip()],
  },
  [SISFieldEnum.Teacher]: {
    options: [
      getOption(VendorLinkFieldEnum.Description),
      getOption(VendorLinkFieldEnum.RoomNumber),
      getOption(VendorLinkFieldEnum.FullName),
      getSkip(),
    ],
  },
  [SISFieldEnum.Birthdate]: {
    options: [getOption(VendorLinkFieldEnum.BirthDate), getSkip()],
  },
  [SISFieldEnum.SSN]: {
    options: [getOption(VendorLinkFieldEnum.SSN), getSkip()],
  },
  [SISFieldEnum.ParentName]: {
    options: [getOption(VendorLinkFieldEnum.ParentName), getSkip()],
  },
  [SISFieldEnum.ParentEmail]: {
    options: [
      getOption(VendorLinkFieldEnum.Primary),
      getOption(VendorLinkFieldEnum.Alternate1),
      getOption(VendorLinkFieldEnum.Alternate2),
      getOption(VendorLinkFieldEnum.Alternate3),
      getOption(VendorLinkFieldEnum.Alternate4),
      getSkip(),
    ],
  },
  [SISFieldEnum.ParentPhoneNumber]: {
    options: [
      getOption(VendorLinkFieldEnum.MainTelephoneNumber),
      getOption(VendorLinkFieldEnum.AlternateTelephoneNumber),
      getOption(VendorLinkFieldEnum.Cell),
      getOption(VendorLinkFieldEnum.Texting),
      getOption(VendorLinkFieldEnum.MotherCell),
      getOption(VendorLinkFieldEnum.FatherCell),
      getOption(VendorLinkFieldEnum.Work),
      getOption(VendorLinkFieldEnum.MotherWork),
      getOption(VendorLinkFieldEnum.FatherWork),
      getOption(VendorLinkFieldEnum.AnsweringService),
      getOption(VendorLinkFieldEnum.BeeperNumber),
      getOption(VendorLinkFieldEnum.AppointmentTelephoneNumber),
      getOption(VendorLinkFieldEnum.TelexNumber),
      getOption(VendorLinkFieldEnum.Telemail),
      getOption(VendorLinkFieldEnum.VoiceMail),
      getOption(VendorLinkFieldEnum.InstantMessagingNumber),
      getOption(VendorLinkFieldEnum.MediaConferencingNumber),
      getOption(VendorLinkFieldEnum.FacsimileNumber),
      getSkip(),
    ],
  },
  [SISFieldEnum.Address]: {
    options: [
      getOption(VendorLinkFieldEnum.MailingAddress),
      getOption(VendorLinkFieldEnum.ShippingAddress),
      getOption(VendorLinkFieldEnum.PhysicalLocationAddress),
      getOption(VendorLinkFieldEnum.OtherHomeAddress),
      getOption(VendorLinkFieldEnum.EmployerAddress),
      getOption(VendorLinkFieldEnum.EmploymentAddress),
      getOption(VendorLinkFieldEnum.OtherOrganizationAddress),
      getSkip(),
    ],
  },
  [SISFieldEnum.Language]: {
    childMap: {
      name: 'Map Languages',
      key: VendorLinkFieldEnum.LanguageMapping,
    },
    options: [
      getOption(VendorLinkFieldEnum.CorrespondenceLanguage),
      getOption(VendorLinkFieldEnum.DominantLanguage),
      getOption(VendorLinkFieldEnum.HomeLanguage),
      getOption(VendorLinkFieldEnum.NativeLanguage),
      getSkip(),
    ],
  },
  // [SISFieldEnum.Allergies]: {
  //   options: [getOption(VendorLinkFieldEnum.Allergies), getSkip()],
  // },
  [SISFieldEnum.StudentStatusCode]: {
    childMap: {
      name: 'Map Status Codes',
      key: VendorLinkFieldEnum.StatusCodeMapping,
    },
    options: [getOption(VendorLinkFieldEnum.StudentStatusCode)],
    props: { upward: true },
  },
};

export const AeriesFieldEnum = {
  BaseUrl: 'BaseUrl',
  Certificate: 'Certificate',
  Enabled: 'Enabled',
  ImportFrequency: 'ImportFrequency',
  StudentNumber: 'StudentNumber',
  StudentFirstName: 'StudentFirstName',
  StudentLastName: 'StudentLastName',
  Site: 'Site',
  Grade: 'Grade',
  Teacher: 'Teacher',
  Birthdate: 'Birthdate',
  ParentName: 'ParentName',
  ParentEmail: 'ParentEmail',
  ParentPhoneNumber: 'ParentPhoneNumber',
  Address: 'Address',
  Language: 'Language',
  ServingNumber: 'ServingNumber',
  SiteMapping: 'SiteMapping',
  GradeMapping: 'GradeMapping',
  LanguageMapping: 'LanguageMapping',
  StudentId: 'StudentId',

  //StudentNumber options
  PermanentId: 'PermanentId',
  OldPermanentId: 'OldPermanentId',
  StateStudentId: 'StateStudentId',

  //Site options
  SchoolCode: 'SchoolCode',

  //Teacher options
  TeacherNumber: 'TeacherNumber',

  //Parent Email options
  ParentEmailAddress: 'ParentEmailAddress',

  //Parent Phone options
  HomePhone: 'HomePhone',

  //Language options
  CorrespondanceLanguageCode: 'CorrespondanceLanguageCode',
  HomeLanguageCode: 'HomeLanguageCode',

  //FirstName options
  FirstName: 'FirstName',

  //LastName options
  LastName: 'LastName',

  //MiddleName options
  MiddleName: 'MiddleName',

  //ParentName options
  ParentGuardianName: 'ParentGuardianName',

  //BirthDate options
  BirthDate: 'BirthDate',
};

export const AeriesMapConfig = {
  [SISFieldEnum.StudentNumber]: {
    options: [
      getOption(AeriesFieldEnum.PermanentId),
      getOption(AeriesFieldEnum.StateStudentId),
      getOption(AeriesFieldEnum.StudentNumber),
      getOption(AeriesFieldEnum.OldPermanentId),
    ],
  },
  [SISFieldEnum.StudentFirstName]: {
    options: [getOption(AeriesFieldEnum.FirstName)],
  },
  [SISFieldEnum.StudentMiddleName]: {
    options: [getOption(AeriesFieldEnum.MiddleName), getSkip()],
  },
  [SISFieldEnum.StudentLastName]: {
    options: [getOption(AeriesFieldEnum.LastName)],
  },
  [SISFieldEnum.Site]: {
    childMap: { name: 'Map Sites', key: AeriesFieldEnum.SiteMapping },
    options: [getOption(AeriesFieldEnum.SchoolCode)],
  },
  [SISFieldEnum.Grade]: {
    childMap: { name: 'Map Grades', key: AeriesFieldEnum.GradeMapping },
    options: [getOption(AeriesFieldEnum.Grade), getSkip()],
  },
  [SISFieldEnum.Teacher]: {
    options: [getOption(AeriesFieldEnum.TeacherNumber), getSkip()],
  },
  [SISFieldEnum.Birthdate]: {
    options: [getOption(AeriesFieldEnum.BirthDate), getSkip()],
  },
  [SISFieldEnum.ParentName]: {
    options: [getOption(AeriesFieldEnum.ParentGuardianName), getSkip()],
  },
  [SISFieldEnum.ParentEmail]: {
    options: [getOption(AeriesFieldEnum.ParentEmailAddress), getSkip()],
  },
  [SISFieldEnum.ParentPhoneNumber]: {
    options: [getOption(AeriesFieldEnum.HomePhone), getSkip()],
  },
  [SISFieldEnum.Address]: {
    options: [getOption(AeriesFieldEnum.Address), getSkip()],
  },
  [SISFieldEnum.Language]: {
    childMap: {
      name: 'Map Languages',
      key: AeriesFieldEnum.LanguageMapping,
    },
    options: [
      getOption(AeriesFieldEnum.CorrespondanceLanguageCode),
      getOption(AeriesFieldEnum.HomeLanguageCode),
      getSkip(),
    ],
  },
  [SISFieldEnum.ServingNumber]: {
    options: [getOption(AeriesFieldEnum.OldPermanentId), getSkip()],
  },
};

export const AeriesMapOptions = [
  {
    key: SISFieldEnum.StudentNumber,
    value: 'Student Number',
  },
  {
    key: SISFieldEnum.StudentFirstName,
    value: 'Student First Name',
  },
  { key: SISFieldEnum.StudentMiddleName, value: 'Student Middle Name' },
  {
    key: SISFieldEnum.StudentLastName,
    value: 'Student Last Name',
  },
  {
    key: SISFieldEnum.Site,
    value: 'Site',
  },
  {
    key: SISFieldEnum.Grade,
    value: 'Grade',
  },
  {
    key: SISFieldEnum.Teacher,
    value: 'Teacher',
  },
  {
    key: SISFieldEnum.Birthdate,
    value: 'Birth Date',
  },
  {
    key: SISFieldEnum.ParentName,
    value: 'Parent Name',
  },
  {
    key: SISFieldEnum.ParentEmail,
    value: 'Parent Email',
  },
  {
    key: SISFieldEnum.ParentPhoneNumber,
    value: 'Parent Phone Number',
  },
  {
    key: SISFieldEnum.Address,
    value: 'Address',
  },
  {
    key: SISFieldEnum.Language,
    value: 'Language',
  },
  { key: SISFieldEnum.ServingNumber, value: 'Serving Number' },
];

export const AeriesPreviewFields = {
  Site: 'Site',
  StudentNumber: 'Student Number',
  StudentFirstName: 'Student First Name',
  StudentLastName: 'Student Last Name',
  StudentMiddleName: 'Student Middle Name',
  Grade: 'Grade',
  Teacher: 'Teacher',
  Birthdate: 'Date of Birth',
  ParentFirstName: 'Parent First Name',
  ParentLastName: 'Parent Last Name',
  ParentEmail: 'Parent Email',
  ParentPhoneNumber: 'Parent Phone Number',
  Address1: 'Address 1',
  Address3: 'Address 3',
  LanguageId: 'LanguageId',
  PermanentId: ' PermanentId',
};



// WEBPACK FOOTER //
// ./src/common/Constants/SISIntegration.js